import React, { ReactNode } from 'react';

import { Box } from '@chakra-ui/react';
import { customTheme } from 'theme';

import { OutlinedFormFieldStyles, OutlinedFormStyles } from '../types';

interface FieldContainerProps {
  children: ReactNode;
  fieldStyles?: OutlinedFormFieldStyles;
  isDisabled?: boolean;
  label?: ReactNode;
  styles?: OutlinedFormStyles;
}

export const FieldContainer = ({
  children,
  fieldStyles,
  isDisabled,
  label,
  styles,
}: FieldContainerProps) => (
  <Box
    // Match the natural field height used by ScanByOutpost, including unlabeled fields.
    h="56px"
    px={4}
    pt={3}
    pb={1}
    border="1px solid"
    borderColor="formFieldBorder"
    borderRadius="xl"
    opacity={isDisabled ? 0.6 : 1}
    {...styles?.field}
    {...fieldStyles?.field}
  >
    {label !== undefined && (
      <Box
        color={customTheme.colors.gray['250']}
        fontSize="14px"
        lineHeight={0.5}
        {...styles?.label}
        {...fieldStyles?.label}
      >
        {label}
      </Box>
    )}
    {children}
  </Box>
);
